import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { useField } from 'formik';

import GenericShippingMethod from './GenericShippingMethod';
import ShippingAddresses from 'components/Checkout/Shipping/ShippingAddresses/ShippingAddresses';
import PackageIcon from 'components/Common/Icons/Delivery/Package';
import { MethodProps } from 'types/ShippingFormType';

import styles from './ShippingMethod.module.scss';

export default function StandardPackage({
  isSelected,
  method: { methodCode, estimateDeliveryDates },
  cart,
  setShippingInformation,
}: MethodProps): JSX.Element {
  const { t } = useTranslation(['checkout']);
  const [{ value: shippingSelected }] = useField('shippingMethod');
  const [{ value: addressSelected }, , { setValue: setAddressType }] = useField(
    'addressType'
  );

  useEffect(() => {
    if (shippingSelected === methodCode) {
      const addressType = addressSelected || 'P';
      if (!addressSelected) {
        setAddressType(addressType, false);
      } else {
        setShippingInformation({
          shippingMethod: methodCode,
          addressType: addressSelected,
        });
      }
    }
  }, [methodCode, shippingSelected, addressSelected]);

  return (
    <GenericShippingMethod
      value={methodCode}
      methodLabel={
        <>
          <span className={styles.methodName}>
            {t('SHIPPING_STANDARD_METHOD_NAME')}
          </span>
          <span className={styles.methodNameExplain}>
            {t('SHIPPING_STANDARD_METHOD_NAME_EXPLAIN')}
          </span>
        </>
      }
      methodIcon={
        <PackageIcon style={{ color: '#333333', fontSize: '32px' }} />
      }
      estimateDeliveryDates={estimateDeliveryDates}
      price={cart.shippingFees}
      freeFrom={
        cart.shippingFees
          ? cart.freeShippingThresholdInformation?.amount
          : undefined
      }
      classes={{
        methodContent: classNames(styles.standardContent, {
          [styles.isSelected]: isSelected,
        }),
      }}
    >
      {isSelected && <ShippingAddresses fieldName={'addressType'} />}
    </GenericShippingMethod>
  );
}
